import { Modal, Spin } from 'antd';
import React, { useState } from 'react';
import { addCredits } from '../../../services/learnerService';
import AddCreditsForm from './AddCreditsForm';

function CreditsAdd(props) {
  const initialValues = {
    reason: '',
    email: props?.learner?.email,
    code: props?.code,
    learner_id: props?.learner?.learnerId,
    isPromoCustom: false
  };

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode'
  });

  async function onSubmit(values) {
    setStatus({ type: 'LOADING', message: 'Request in Progress!' });

    const updatedValues = {
      email: props?.learner?.email,
      code: values?.code,
      discountValue: parseInt(values?.discountValue * 100),
      learnerObjectId: props?.learner?._id
    };

    await addCredits(updatedValues)
      .then((response) => {
        console.log('Successfully Added! ', response);
        setStatus({
          type: 'SUCCESS',
          message: 'Data added successfully!'
        });
        props.onSuccess();
      })
      .catch((error) => {
        alert('Getting data from the backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  }

  return (
    <Modal
      title={`Add Credits`}
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={null}>
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <AddCreditsForm
          type="Add"
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
        />
      )}
    </Modal>
  );
}

export default CreditsAdd;
